import { styled } from "@mui/material/styles";
import { Box, Card, TableContainer } from "@mui/material";

export const DashboardContainer = styled(Box)(() => ({
  backgroundColor: "#121212",
  minHeight: "100vh",
  padding: "24px",
}));

export const SectionCard = styled(Card)(() => ({
  backgroundColor: "#1A1A1A",
  border: "1px solid #333",
  borderRadius: "12px",
}));

export const StyledTableContainer = styled(TableContainer)(() => ({
  backgroundColor: "#1A1A1A",
  borderRadius: "8px",
  "& .MuiTableHead-root": {
    backgroundColor: "#121212",
  },
  "& .MuiTableCell-root": {
    borderColor: "#333",
    color: "#fff",
  },
  "& .MuiTableCell-head": {
    backgroundColor: "#121212",
    fontWeight: 600,
    color: "#4CAF50",
  },
}));

export const AnswerCard = styled(Box)(({ isCorrect }) => ({
  backgroundColor: isCorrect ? "rgba(76, 175, 80, 0.1)" : "rgba(255, 255, 255, 0.02)",
  border: `1px solid ${isCorrect ? "#4CAF50" : "#333"}`,
  borderRadius: "8px",
  padding: "12px",
  marginBottom: "8px",
}));

export const SongClueCard = styled(Box)(() => ({
  backgroundColor: "rgba(255, 255, 255, 0.03)",
  border: "1px solid #333",
  borderRadius: "12px",
  padding: "12px",
  marginBottom: "12px",
  display: "flex",
  gap: "12px",
  alignItems: "flex-start",
  boxShadow: "0 0 0 1px rgba(76, 175, 80, 0.15)",
}));
